export const environment = {
  firebase: {
    projectId: 'myshoppinglist-76c55',
    appId: '1:1031089451713:web:4c3f8dcc7f09e24ccf5a40',
    databaseURL: 'https://myshoppinglist-76c55.firebaseio.com',
    storageBucket: 'myshoppinglist-76c55.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyCfPUzU8iFjyW-VChOkKInD7jFhX024zg0',
    authDomain: 'myshoppinglist-76c55.firebaseapp.com',
    messagingSenderId: '1031089451713',
    measurementId: 'G-4KSSJYX5G1',
  },
  version:'1.0.14',
  production: true,
  baseUrl: 'https://api.pigeonpad.pk/api/v1',
};
